import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config';
import { toApiError } from '../lib/api-error';

type QaRunHistoryItem = {
  id: string;
  propertyName: string;
  startedAt: string | null;
  finishedAt: string | null;
  healthyTests: number;
  unhealthyTests: number;
  passRate: number;
};

type ApiResponse = {
  ok: boolean;
  runs: QaRunHistoryItem[];
};

export function useQaRunHistory(limit = 20) {
  return useQuery({
    queryKey: ['qa-run-history', limit],
    queryFn: async (): Promise<QaRunHistoryItem[]> => {
      const res = await fetch(`${API_URL}/dashboard/qa-run-history?limit=${limit}`, {
        credentials: 'include',
      });
      if (!res.ok) {
        throw await toApiError(res, 'Failed to fetch QA run history');
      }
      const body = (await res.json()) as ApiResponse;
      if (!body.ok) {
        throw new Error('QA run history response was not ok');
      }
      return body.runs;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
